import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

const DEFAULT_TITLE = "Federal Polytechnic Bida | Admissions, Programmes, News & Research";
const DEFAULT_DESCRIPTION = "Official website of Federal Polytechnic Bida. Explore admissions, departments, notices, news, research, journals, alumni, partnerships and campus resources.";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let tag = document.querySelector(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setCanonical(url) {
  if (!url) return;
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

export default function SEOManager() {
  const location = useLocation();

  useEffect(() => {
    let active = true;
    const path = location.pathname || "/";

    async function loadSeo() {
      try {
        const seo = await api(`/api/seo/page?path=${encodeURIComponent(path)}`);
        if (!active) return;
        const title = seo.title || DEFAULT_TITLE;
        const description = seo.description || DEFAULT_DESCRIPTION;
        document.title = title;
        setMeta("description", description);
        setMeta("keywords", seo.keywords || "Federal Polytechnic Bida, FPB, admissions, departments, research");
        setMeta("robots", seo.robots || "index,follow");
        setMeta("og:title", seo.og_title || title, "property");
        setMeta("og:description", seo.og_description || description, "property");
        setMeta("og:type", "website", "property");
        if (seo.og_image) setMeta("og:image", seo.og_image, "property");
        setMeta("twitter:card", seo.og_image ? "summary_large_image" : "summary");
        setMeta("twitter:title", seo.og_title || title);
        setMeta("twitter:description", seo.og_description || description);
        if (seo.canonical_url) setCanonical(seo.canonical_url);

        const oldSchema = document.getElementById("fpb-page-schema");
        if (oldSchema) oldSchema.remove();
        if (seo.schema_json) {
          const script = document.createElement("script");
          script.type = "application/ld+json";
          script.id = "fpb-page-schema";
          script.textContent = seo.schema_json;
          document.head.appendChild(script);
        }
      } catch {
        if (!active) return;
        document.title = DEFAULT_TITLE;
        setMeta("description", DEFAULT_DESCRIPTION);
      }
    }

    loadSeo();
    return () => { active = false; };
  }, [location.pathname]);

  return null;
}
